<template>
  <div class="mb-3">
    <div class="d-flex mb-2">
      <b-input-group class="flex-grow-1">
        <b-input-group-prepend is-text>
          <b-icon icon="search" />
        </b-input-group-prepend>
        <b-input
          v-model="phoneInput"
          type="tel"
          placeholder="Nr telefonu"
          @keydown.enter="submitPhone"
          @blur="submitPhone"
        />
      </b-input-group>
      <b-button variant="primary" size="sm" class="ml-2" @click="clearAll">
        <b-icon icon="x" />
      </b-button>
    </div>

    <b-input-group class="mb-2">
      <b-input-group-prepend is-text>
        <b-icon icon="scissors" />
      </b-input-group-prepend>
      <b-form-select
        :value="value.barber_id"
        :options="barberOptions"
        @change="updateFilter('barber_id', $event)"
      />
    </b-input-group>

    <b-input-group>
      <b-input-group-prepend is-text>
        <b-icon icon="funnel-fill" />
      </b-input-group-prepend>
      <b-form-select
        :value="value.type"
        :options="typeOptions"
        @change="updateFilter('type', $event)"
      />
    </b-input-group>
  </div>
</template>

<script>
import { ReservationLogType, ReservationLogTypeLabels } from '@/Enums/ReservationLogType'

export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
    barbers: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      phoneInput: this.value.phone || '',
    }
  },
  computed: {
    barberOptions() {
      return [
        { value: '', text: 'Wszyscy fryzjerzy' },
        ...this.barbers.map(b => ({ value: b.id, text: b.name })),
      ]
    },
    typeOptions() {
      return [
        { value: '', text: 'Wszystkie typy' },
        ...Object.entries(ReservationLogTypeLabels).map(([value, text]) => ({
          value: Number(value),
          text,
        })),
      ]
    },
  },
  methods: {
    submitPhone() {
      if (this.phoneInput !== this.value.phone) {
        this.updateFilter('phone', this.phoneInput)
      }
    },
    clearAll() {
      this.phoneInput = ''
      this.$emit('filter-change', { phone: '', barber_id: '', type: '' })
    },
    updateFilter(key, val) {
      this.$emit('filter-change', { ...this.value, [key]: val })
    },
  },
}
</script>
